import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Franchise from "./component";
import { updateSSRStatus } from "../../shared/meta-tags/actions";
import { fetchGalleryContent, setIsSsr } from "./actions";

const mapStateToProps = ({
    meta: { genericContent },
    franchise: { testimonials, isSSR }
}) => ({
    genericContent,
    testimonials,
    isSSR
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    updateSSRStatusConnect: updateSSRStatus,
    setIsSSRConnect: setIsSsr,
    fetchTestimonialsConnect: fetchGalleryContent
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Franchise);
